"use client";

import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { GradePricing } from "./grade-row";

export function useGradePricing(
  productTypeSlug: string,
  conditions: string[],
  quantity: number,
  initialQuantity: number,
  initialPricing: GradePricing[],
): GradePricing[] {
  const { isAuthenticated } = useConvexAuth();
  const needsLive = isAuthenticated || quantity !== initialQuantity;
  const live = useQuery(
    api.priceIndex.conditionBands.getConditionPriceBands,
    needsLive ? { productTypeSlug, conditions, quantity } : "skip",
  );
  return live ?? initialPricing;
}
